import { render, staticRenderFns } from "./CesiumPlugin.vue?vue&type=template&id=632b74fa&scoped=true"
import script from "./CesiumPlugin.vue?vue&type=script&lang=ts"
export * from "./CesiumPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CesiumPlugin.vue?vue&type=style&index=0&id=632b74fa&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "632b74fa",
  null
  ,true
)

export default component.exports